import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { OrderApiConfiguration } from '../order-api-configuration';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
import { PayerService } from 'app/shared/models/orders-and-billing/payer-service';

@Injectable()
export class PayerServiceService extends ServiceBase {

    private actionUrl: string;
    private url: string;
    private byPayerIdUrl: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this.url = this.actionUrl + _configuration.payerService.url;
        this.byPayerIdUrl = this.actionUrl + _configuration.payerService.byPayerId;
    }

    getByPayerId = (payerId: number): Observable<PayerService[]> => {
        return this._http.get<any>(`${this.byPayerIdUrl}?payerId=${payerId}`);
    }

    insert = (data: PayerService): Observable<PayerService> => {
        return this._http.post<any>(this.url, data);
    }

    update = (data: PayerService): Observable<PayerService> => {
        return this._http.put<any>(this.url, data);
    }
}